/**
 * @param onClicked {() => void}
 * @return {void}
 */
module.exports = function listenForWhitepaper2024ReturningUserShowContentButtonClick(onClicked) {
    document.querySelectorAll('[data-component="whitepaper-returning-user-show-content-button"]').forEach(showContentButton => {
        if (showContentButton instanceof HTMLElement) {
            showContentButton.addEventListener('click', (e) => {
                e.preventDefault();

                onClicked();
            });
        }
    });
}
